// ⬡B:ms_mac_core.Mark:CODE:ms_mac_persona_clone_fix:20260607⬡
// Ms.Ria wordmark — circular R orb + name. Extracted from apps/msria-home/src/Chat.jsx.
import React from 'react';
import { C } from './tokens.js';

export function Mark({ size = 26 }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
      <div style={{
        width: size + 6, height: size + 6, borderRadius: '50%',
        background: 'linear-gradient(135deg,#e8b4a0,#b08d57)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0, boxShadow: '0 0 12px rgba(232,150,170,.4)',
        fontWeight: 600, fontSize: Math.round(size * 0.55), color: '#0a0a0c',
      }}>R</div>
      <span style={{ color: C.platinum, fontSize: Math.round(size * 0.72), fontWeight: 600, letterSpacing: .3 }}>
        Ms<span style={{ color: C.rose }}>.</span>Ria
      </span>
    </div>
  );
}
